import intl from "react-intl-universal";
import {
  TbArrowsExchange,
  TbCalendar,
  TbCoins,
  TbCurrencyReal,
  TbSwitchHorizontal,
} from "react-icons/tb";
import { ModernFilterBar } from "../../../../Components/Molecules/Filters/ModernFilterBar";
import {
  AmountFilterPanel,
  CheckboxListFilterPanel,
  DateFilterPanel,
} from "../../../../Components/Molecules/Filters/ModernFilterPanels";
import {
  EMPTY_BAAS_EXTRATO_FILTERS,
  buildBaasExtratoFilterTags,
  getBaasExtratoCurrencyOptions,
  getBaasExtratoDirectionOptions,
  getBaasExtratoRailOptions,
  hasActiveBaasExtratoFilters,
  isBaasExtratoChipFilterActive,
  removeBaasExtratoFilterTag,
} from "./baasExtratoFilters";

export const BaasExtratoFilterBar = ({
  filters,
  onFiltersChange,
  filteredItems,
  items = [],
  accountCurrencies = [],
}) => {
  const currencyOptions = getBaasExtratoCurrencyOptions(items, accountCurrencies);

  const filterButtons = [
    {
      id: "date",
      icon: TbCalendar,
      label: intl.get("extract.filterDate"),
      active: isBaasExtratoChipFilterActive(filters, "date"),
    },
    {
      id: "amount",
      icon: TbCurrencyReal,
      label: intl.get("extract.filterAmount"),
      active: isBaasExtratoChipFilterActive(filters, "amount"),
    },
    {
      id: "type",
      icon: TbSwitchHorizontal,
      label: intl.get("extract.filterType"),
      active: isBaasExtratoChipFilterActive(filters, "type"),
    },
    {
      id: "direction",
      icon: TbArrowsExchange,
      label: intl.get("baas.transactions.detail.direction"),
      active: isBaasExtratoChipFilterActive(filters, "direction"),
    },
    {
      id: "currency",
      icon: TbCoins,
      label: intl.get("baas.extrato.filterCurrency"),
      active: isBaasExtratoChipFilterActive(filters, "currency"),
    },
  ];

  const renderPanelContent = (panelId, draft, onChange) => {
    switch (panelId) {
      case "date":
        return <DateFilterPanel draft={draft} onChange={onChange} />;
      case "amount":
        return (
          <AmountFilterPanel draft={draft} onChange={onChange} idPrefix="baas-extrato" />
        );
      case "type":
        return (
          <CheckboxListFilterPanel
            options={getBaasExtratoRailOptions()}
            selectedValues={draft.types || []}
            onChange={(types) => onChange({ ...draft, types })}
            idPrefix="baas-extrato-rail"
          />
        );
      case "direction":
        return (
          <CheckboxListFilterPanel
            options={getBaasExtratoDirectionOptions()}
            selectedValues={draft.directions || []}
            onChange={(directions) => onChange({ ...draft, directions })}
            idPrefix="baas-extrato-direction"
          />
        );
      case "currency":
        return (
          <CheckboxListFilterPanel
            options={currencyOptions}
            selectedValues={draft.currencies || []}
            onChange={(currencies) => onChange({ ...draft, currencies })}
            idPrefix="baas-extrato-currency"
          />
        );
      default:
        return null;
    }
  };

  return (
    <ModernFilterBar
      filters={filters}
      onFiltersChange={onFiltersChange}
      emptyFilters={EMPTY_BAAS_EXTRATO_FILTERS}
      searchPlaceholder={intl.get("extract.searchTransaction")}
      filterButtons={filterButtons}
      buildFilterTags={buildBaasExtratoFilterTags}
      hasActiveFilters={hasActiveBaasExtratoFilters}
      removeFilterTag={removeBaasExtratoFilterTag}
      renderPanelContent={renderPanelContent}
      filteredItems={filteredItems}
      panelTitles={{
        date: intl.get("extract.filterDate"),
        amount: intl.get("extract.filterAmount"),
        type: intl.get("extract.filterType"),
        direction: intl.get("baas.transactions.detail.direction"),
        currency: intl.get("baas.extrato.filterCurrency"),
      }}
    />
  );
};
